<template>
  <div>
    <el-card
      class="absolute model-edit bg-[rgba(46,107,176,0.5)] w-368px text-white p-10px"
      :style="{
        height: location.height,
        top: location.top,
        right: location.float === 'right' ? '0px' : '',
        left: location.float === 'left' ? '25px' : '',
      }"
    >
      <div slot="header" class="flex justify-between">
        <span class="text-14px">节点编辑树</span>
        <div class="flex text-right">
          <el-tooltip
            v-if="customProps.sceneOptions.isEnableGis"
            content="设置GIS原点"
            :open-delay="1000"
            effect="light"
          >
            <el-button
              type="primary"
              :loading="showLoadProgress"
              @click="setGisOriginPoint"
              class="iconfont icon-bg-localtion"
            ></el-button>
          </el-tooltip>
          <!-- <el-tooltip content="导出为pr文件" :open-delay="1000" effect="light">
            <el-button
              type="primary"
              :loading="showLoadProgress"
              class="iconfont icon-line-upload"
              @click="uploadPrFile"
            ></el-button>
          </el-tooltip> -->
          <el-tooltip content="保存修改" :open-delay="1000" effect="light">
            <el-button
              type="primary"
              class="iconfont icon-bg-save"
              @click="saveEngineerData"
              :disabled="saveDisable"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="修改节点名称" :open-delay="1000" effect="light">
            <el-button
              type="primary"
              class="iconfont icon-line-edit"
              @click="editNodeName"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="删除节点" :open-delay="1000" effect="light">
            <el-button
              type="danger"
              class="iconfont icon-line-close"
              @click="deleteNode"
            ></el-button>
          </el-tooltip>
          <el-tooltip content="新增节点" :open-delay="1000" effect="light">
            <el-button
              type="primary"
              class="iconfont icon-line-circleAdd"
              @click="createNode"
            ></el-button>
          </el-tooltip>
          <span
            class="ml-10px iconfont icon-line-close float-right cursor-pointer text-12px"
            @click="closeComponent"
          ></span>
        </div>
      </div>

      <div class="h-45px p-5px mt-5px">
        <el-input
          size="small"
          placeholder="请输入要过滤的设备"
          v-model="filterTreeKeyWords"
          @keypress.native.enter="filterModelTree(0,  filterTreeKeyWords)"
          clearable
        >
          <el-button
            slot="append"
            icon="iconfont icon-line-down"
            @click="filterModelTree(currentNodeData.node, filterTreeKeyWords)"
            class="pl-10px pr-10px text-12px"
          ></el-button>
          <el-button
            slot="append"
            icon="iconfont icon-line-up"
            @click="filterModelTree(currentNodeData.node, filterTreeKeyWords)"
            class="pl-10px pr-10px mr-1px text-12px"
          ></el-button>
        </el-input>
      </div>
      <div class="h-[calc(100%-45px)]" @click="menuVisible = false" v-loading="!treeShow">
        <el-tree
          v-if="treeShow"
          :props="defaultProps"
          :load="loadNode"
          ref="modelTree"
          id="modelTree"
          node-key="node"
          draggable
          lazy
          show-checkbox
          highlight-current
          :default-expanded-keys="defaultExpandedKeys"
          :default-checked-keys="modelTreeProp.defaultCheckedKey"
          @check="checkModelTree"
          @node-click="clickModelTree"
          @node-drop="handleNodeDrop"
          @node-collapse="handleNodeCollapse"
          :allowDrag="allowDrag"
          :allowDrop="allowDrop"
          :allow-drag="allowDrag"
          :allow-drop="allowDrop"
        >
          <div
            @contextmenu.prevent="
              (e) => {
                showMenus(e, node, data)
              }
            "
            class="custom-tree-node overflow-hidden w-full flex justify-between"
            slot-scope="{ node, data }"
          >
            <span class="text-12px">{{ data.name }}</span>
          </div>
        </el-tree>
      </div>
      <div
        class="menu-card fixed bg-[rgba(24,41,72,0.8)] z-400w-150px rounded-3px text-white"
        v-if="menuVisible"
        @click="menuVisible = false"
        :style="{ left: positon.X + 'px', top: positon.Y + 'px' }"
      >
        <div
          class="menu-item w-full cursor-pointer text-12px p-10px"
          v-if="ableCreate"
          @click="createNode"
        >
          新增节点
        </div>
        <div
          class="menu-item w-full cursor-pointer text-12px p-10px"
          v-if="ableDelete"
          @click="deleteNode"
        >
          删除节点
        </div>
        <div
          class="menu-item w-full cursor-pointer text-12px p-10px"
          v-if="ableEdit"
          @click="editNodeName"
        >
          修改节点名称
        </div>
      </div>
      <el-dialog
        :title="isCreate ? '模型节点新增' : '模型节点编辑'"
        :visible.sync="modifyVisible"
        :close-on-click-modal="false"
        :lock-scroll="false"
        :before-close="modifyDialogClose"
        width="25%"
      >
        <div>
          <el-form ref="modifyForm" :model="modifyForm" :rules="modifyRules" label-width="80px">
            <el-form-item label="节点名称" prop="name">
              <el-input
                v-model="modifyForm.name"
                clearable
                placeholder="请输入节点名称"
                size="small"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <el-button type="primary" @click="saveNodeInfo" size="small">确 定</el-button>
          <el-button @click="modifyDialogClose" size="small">取 消</el-button>
        </div>
      </el-dialog>
    </el-card>
    <!-- 模型进度条 -->
    <player-progress
      :loadType="loadType"
      :percentage="loadPercentage"
      v-if="showLoadProgress"
    ></player-progress>
    <SetOriginPoint
      v-if="originPointOptionsVisible"
      :player="player"
      :modifyOptions="originPointOptions"
      @close="setOriginPointClose"
      @setSucess="setOriginPointSuccess"
    ></SetOriginPoint>
    <MergeSceneFile
      v-if="addModelVisible"
      :visible="addModelVisible"
      :mediaTypes="mediaTypeParams"
      @close="closeAddModel"
    ></MergeSceneFile>
    <img :src="imgChangeUrl" alt="" class="mt-800px" id="rotateImg" v-if="true" />
  </div>
</template>
<script>
import html2canvas from 'html2canvas'
import { ModelSceneApi } from '@wiz-api/scene-management'
import { FileApi } from '@wiz-api/file-management'
import { saveSceneToJson, isJSONObj, EnumObjectTypes } from '../../assets/js/scene/scene'
import setModelVisible from '../../assets/js/model/modelTree'

const fileApi = new FileApi()

const modelSceneApi = new ModelSceneApi()

const PlayerProgress = () => {
  return import('../model/PlayerProgress')
}
const SetOriginPoint = () => {
  return import('../dialog/SetOriginPoint')
}
const MergeSceneFile = () => {
  return import('../dialog/MergeSceneFile')
}
export default {
  name: 'NodeEditTree',
  mixins: [],
  components: { PlayerProgress, SetOriginPoint, MergeSceneFile },
  props: ['location', 'player', 'customProps', 'loadModelStatus'],
  data() {
    return {
      addModelVisible: false,
      originPointOptionsVisible: false,
      originPointOptions: {
        id: '',
        name: '',
        longitude: '',
        latitude: '',
        folderId: '',
        isEnableGis: '',
      },
      showTemporaryImg: false,
      thumbnailUrl: '',
      imgChangeUrl: '',
      positon: {
        X: '',
        Y: '',
      },
      menuVisible: false,
      input: '',
      defaultProps: {
        label: 'name',
        children: 'zones',
      },
      count: 1,
      modifyVisible: false, // 编辑框显隐
      modifyForm: { name: '' },
      modifyRules: { name: [{ required: true, message: '请输入节点名称', trigger: 'change' }] },
      treeShow: false,
      ableDelete: false,
      ableCreate: false,
      ableEdit: false,
      currentNodeData: {},
      currentTreeNode: null,
      defaultExpandedKeys: [],
      saveStatus: false,
      filterTreeKeyWords: '',
      loadType: '',
      loadPercentage: 0,
      showLoadProgress: false,
      engineerThumbnails: '',
      engineerName: '',
      isCreate: false,
      uploadLoading: false,
      exportPath: '',
      textureFileId: '',
      prFileId: '',
      exportPrName: '',
      // 模型树相关
      modelTreeProp: {
        currentNodeItem: 0, // 当前激活的node
        currentNodeName: '', // 点选时当前激活的节点名称
        treeData: [], // 模型树数据
        defaultCheckedKey: [], // 模型树选中的节点
        filterItem: [], // 模型树不需要显示的节点及他的父节点列表
        modelHideList: [], // 模型隐藏队列
        modelTreeLoadEnd: false, // 模型树数据加载完毕
      },
      saveDisable: false,
    }
  },
  watch: {
    'customProps.addModel': {
      handler(vals) {
        if (vals?.length && vals[0]?.node) {
          vals.forEach((val) => {
            this.$refs.modelTree.append(val, val.parent)
            this.$refs.modelTree.setChecked(val, true)
          })
        }
      },
      deep: true,
    },
    'customProps.currentNodeData': {
      handler(data) {
        if (data && data.node) {
          this.currentNodeData = data
          // 展开树
          this.expendNode(data)
        }
      },
      deep: true,
      immediate: true,
    },
    async loadModelStatus(val) {
      if (val) {
        // 获取模型数据
        const rootNode = await this.player.Native.Node.getRoot()
        const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
        this.modelTreeProp.treeData = currentProperty.children
        this.treeShow = true
      }
    },
  },
  async created() {
    if (this.loadModelStatus) {
      // 获取模型数据
      const rootNode = await this.player.Native.Node.getRoot()
      const currentProperty = await this.player.Native.Node.getProperty(rootNode, ['children'])
      this.modelTreeProp.treeData = currentProperty.children
      this.treeShow = true
    }
  },
  beforeDestroy() {},
  computed: {
    // 模型相关设置
    modelSetting() {
      return Wiz.globalSettings.globalConfig?.modelSetting || {}
    },
  },
  async mounted() {},
  methods: {
    setOriginPointClose() {
      this.originPointOptionsVisible = false
    },
    async setOriginPointSuccess(data) {
      const elevation = (
        await this.player.Native.GisPlatform.queryDEM([[data.longitude, data.latitude]])
      )[0]
      this.player.Native.Camera.addMoveToLLH([data.longitude, data.latitude, elevation + 800], 2)
      this.customProps.sceneOptions.longitude = data.longitude
      this.customProps.sceneOptions.latitude = data.latitude
      // 在跟节点集合中查找我们设置的场景的跟节点
      const root = await this.player.Native.Node.getRoot()
      const rootinfo = await this.player.Native.Node.getProperty(root, ['children'])
      const currentRoot = rootinfo.children[0]
      if (currentRoot.node) {
        const llh = [data.longitude, data.longitude, 0]
        llh[2] = (await this.player.Native.GisPlatform.queryDEM([llh]))[0]
        const mat = await this.player.Native?.GisPlatform.makeGisTransform(llh)
        await this.player.Native.Node.setProperty(currentRoot.node, { wholeMatrix: mat })
      }
    },
    // 设置gis原点
    setGisOriginPoint() {
      this.originPointOptionsVisible = true
      this.originPointOptions = _.pick(this.customProps.sceneOptions, [
        'id',
        'name',
        'longitude',
        'latitude',
        'folderId',
        'isEnableGis',
      ])
    },
    // 关闭新增模型弹窗
    closeAddModel(isSave) {
      this.addModelVisible = false
      if (isSave) {
        this.$confirm(
          '模型发布成功，是否将当前场景内容替换为发布的模型，此操作会删除场景中原有的对象！',
          '提示',
          {
            confirmButtonText: '覆盖',
            cancelButtonText: '取消',
            type: 'warning',
          }
        ).then(async () => {})
      }
    },
    // 组装文件相关数据
    async setMediaTypes() {
      // 新增操作时，截图操作
      const captureDom = document.querySelector('#playerEngineId')
      this.showTemporaryImg = true
      this.imgChangeUrl = await this.getConvertToImage(captureDom)
      setTimeout(async () => {
        const captureDomAfter = document.querySelector('#rotateImg')
        this.thumbnailUrl = await this.getConvertToImage(captureDomAfter)
        this.showTemporaryImg = false
        const file = await this.dataURLtoFile(this.thumbnailUrl, '缩略图.png')
        const [err, res] = await fileApi.upload({
          files: [file],
          authLevel: 2,
        })
        let thumbnailId = ''
        if (!err && res.length) {
          thumbnailId = res[0].id
        }
        this.mediaTypeParams = [
          {
            fileInfoId: this.prFileId,
            mediaType: 1,
          },
          {
            fileInfoId: this.textureFileId,
            mediaType: 2,
          },
        ]
        if (thumbnailId) {
          this.mediaTypeParams.push({
            fileInfoId: thumbnailId,
            mediaType: 3,
          })
        }
        this.addModelVisible = true
      }, 0)
    },
    // 获取截图后的快照
    getConvertToImage(container, options = {}) {
      // 获取指定的宽高
      const width = parseInt(window.getComputedStyle(container).width, 10)
      const height = parseInt(window.getComputedStyle(container).height, 10)
      // // html2canvas配置项
      const ops = {
        width,
        height,
        useCORS: true,
        allowTaint: true,
        ...options,
        dpi: 300,
      }
      return html2canvas(container, ops).then((canvas) => {
        return canvas.toDataURL('image/png')
      })
    },
    // 图片转文件
    dataURLtoFile(dataurl, filename) {
      // 将base64转换为文件，dataurl为base64字符串，filename为文件名（必须带后缀名，如.jpg,.png）
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    // 监听上传成功
    // uploadFinish(file, err, ret, total) {
    //   try {
    //     const result = JSON.parse(ret)
    //     if (result && !_.isEmpty(result)) {
    //       this.prFileId = result[0].id
    //       this.setMediaTypes()
    //     } else {
    //       this.uploadLoading = false
    //     }
    //   } catch (error) {}
    //   this.player.Native.File.EventUploadFinish.disconnect(this.uploadFinish)
    // },
    // 上传附件结束
    // async uploadTextureFinish(file, err, ret, total) {
    //   await this.player.Native.File.EventUploadFinish.disconnect(this.uploadTextureFinish)
    //   await this.player.Native.File.EventUploadProcessChanged.disconnect(this.uploadTextureProcess)
    //   this.showLoadProgress = false
    //   this.loadPercentage = 0
    //   try {
    //     const result = JSON.parse(ret)
    //     if (result && !_.isEmpty(result)) {
    //       this.textureFileId = result[0].id
    //     } else {
    //       this.uploadLoading = false
    //     }
    //   } catch (error) {}
    //   await this.player.Native.File.EventUploadFinish.connect(this.uploadFinish)
    //   await this.player.Native.File.uploadFile(
    //     `${Wiz.GetApiClientInstance()?.basePath}/api/file-management/files/upload`,
    //     {
    //       'Content-Type': 'multipart/form-data',
    //       Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
    //     },
    //     { files: `@${this.exportPath}/${this.exportPrName}.pr` }
    //   )
    // },
    // 上传附件进度
    // uploadTextureProcess(file, bytesReceived, bytesTotal) {
    //   if (bytesTotal > 0) {
    //     this.loadPercentage = (bytesReceived / bytesTotal) * 100
    //   }
    // },
    // 合并文件
    // async mergeFile() {
    //   const rootItem = await this.player.Native.ModelTree.getRootItems()
    //   // 在跟节点集合中查找我们设置的场景的跟节点
    //   const rootNode = _.find(rootItem, (val) => {
    //     return val.code && isJSONObj(val.code) && JSON.parse(val.code).type === 'Root'
    //   })
    //   const data = await saveSceneToJson(rootNode.node, this.player)
    //   const filePathList = this.getFilePath(data, [])
    //   this.exportPath = `data://../apps/${this.modelSetting.folderName}/export/${this.$route.query.sceneId}`
    //   this.exportPrName = data.name
    //   let transformMat = null
    //   let exportRes = null
    //   if (this.customProps.sceneOptions.isEnableGis) {
    //     const llh = [
    //       this.customProps.sceneOptions.longitude * 1,
    //       this.customProps.sceneOptions.latitude * 1,
    //       0,
    //     ]
    //     llh[2] = (await this.player.Native.GisPlatform.queryDEM([llh]))[0]
    //     transformMat = await this.player.Native.GisPlatform.makeGisTransform(llh)
    //     exportRes = await this.player.Native.NodeProxy.exportNodes(
    //       `${this.exportPath}/${this.exportPrName}.pr`,
    //       filePathList,
    //       true,
    //       transformMat
    //     )
    //   } else {
    //     exportRes = await this.player.Native.NodeProxy.exportNodes(
    //       `${this.exportPath}/${this.exportPrName}.pr`,
    //       filePathList,
    //       true
    //     )
    //   }
    //   return exportRes
    // },
    // 导出为pr文件并上传到文档管理
    // async uploadPrFile() {
    //   this.uploadLoading = true
    //   const exportRes = await this.mergeFile()
    //   if (exportRes) {
    //     await this.player.Native.File.EventUploadFinish.connect(this.uploadTextureFinish)
    //     await this.player.Native.File.EventUploadProcessChanged.connect(this.uploadTextureProcess)
    //     const uploadRes = await this.player.Native.File.uploadFile(
    //       `${Wiz.GetApiClientInstance()?.basePath}/api/file-management/files/upload`,
    //       {
    //         'Content-Type': 'multipart/form-data',
    //         Authorization: `Bearer ${Wiz.AuthHooks.GetToken()}`,
    //       },
    //       { files: `@${this.exportPath}/Texture.zip` }
    //     )
    //     if (uploadRes) {
    //       this.loadType = '上传贴图文件...'
    //       this.showLoadProgress = true
    //     }
    //   } else {
    //     this.$message.warning('未找到加载的模型文件')
    //   }
    // },
    // 获取文件路径集合
    // getFilePath(data, arr = []) {
    //   if (data.code && data.code.filePath) {
    //     arr.push(data.code.filePath)
    //   }
    //   if (!_.isEmpty(data.children)) {
    //     for (let i = 0; i < data.children.length; i += 1) {
    //       this.getFilePath(data.children[i], arr)
    //     }
    //   }
    //   return arr
    // },
    // 收起节点
    handleNodeCollapse(data) {
      _.remove(this.defaultExpandedKeys, (item) => {
        return item === data.item
      })
    },
    // 保存模型修改
    async saveEngineerData() {
      if (this.$route.query.sceneId) {
        // 从模型树的上拿到根节点
        const root = await this.player.Native.Node.getRoot()
        const info = await this.player.Native.Node.getProperty(root, ['children'])
        const rootNode = info.children[0]
        if (rootNode) {
          const data = await saveSceneToJson(rootNode.node, this.player)
          const [err, res] = await modelSceneApi.saveModelSecenRelatedJson({
            body: {
              id: this.customProps.sceneOptions.id,
              jsonContent: JSON.stringify(data),
            },
          })
          if (!err) {
            this.$message.success('保存成功')
          }
        }
      }
    },
    // 展开节点
    handleNodeExpand(data) {
      this.defaultExpandedKeys.push(data.item)
    },
    async filterModelTree(startNode, KeyWords) {
      // 过滤模型树
      const res = await this.player.Native.Node.findNode(startNode, {
        names: [KeyWords],
        codes: [KeyWords],
      })
      const currentNodeData = res.codes
        ? res.codes[KeyWords] || {}
        : res.names
        ? res.names[KeyWords] || {}
        : {}
      // 展开树
      if (!_.isEmpty(currentNodeData)) {
        this.$emit('componentEmit', 'currentNodeData', currentNodeData)
      } else {
        // 未找到
        this.$message({
          showClose: true,
          message: '搜索结果到底了',
          type: 'error',
        })
      }
    },

    // 展开节点树
    async expendNode(node, doLocation) {
      const rootNode = await this.player.Native.Node.getRoot()
      const rootChild = await this.player.Native.Node.getProperty(rootNode, ['children'])
      if (node.node === rootChild.children[0]?.node) {
        // 到达根节点 执行点击事件
        this.$nextTick(() => {
          this.clickModelTree(this.currentNodeData, { checked: true }, doLocation)

          this.locationNode(this.currentNodeData.node)
        })
      } else {
        const res = await this.player.Native.Node.getProperty(node.node, ['parent'])
        const currentLevelNodes = await this.player.Native.Node.getProperty(res.parent, [
          'children',
        ])
        const parentInfo = await this.player.Native.Node.getProperty(res.parent, ['code', 'name'])
        let expandIndex = null
        if (currentLevelNodes.children?.length > 1000) {
          expandIndex = _.findIndex(currentLevelNodes.children, ['node', node.node])
        }
        await this.expendNode(parentInfo, doLocation)
        if (!this.defaultExpandedKeys.includes(parentInfo.node)) {
          // 展开
          this.defaultExpandedKeys.push(parentInfo.node)
        }
        if (!_.isNil(expandIndex) && expandIndex > -1) {
          this.defaultExpandedKeys.push(
            `${parentInfo.node}${
              expandIndex % 1000 === 0 ? expandIndex / 1000 : _.ceil(expandIndex / 1000) - 1
            }`
          )
        }
      }
    },
    // 保存节点信息
    saveNodeInfo() {
      this.$refs.modifyForm.validate(async (valid) => {
        if (valid) {
          let currentNode = null
          const parentNode = this.isCreate ? this.currentTreeNode : this.currentTreeNode.parent
          const findNode = parentNode.childNodes.find((item) => {
            return item.label === this.modifyForm.name
          })
          if (findNode) {
            this.$message.warning('该节点下已存在相同名称的节点')
            return
          }
          if (this.isCreate) {
            // 新增
            currentNode = await this.player.Native.Node.create()
            const nodeInfo = {
              node: currentNode,
              name: this.modifyForm.name,
              parent: this.currentNodeData.node,
              code: JSON.stringify({ type: 'userData' }),
            }
            await this.player.Native.Node.setProperty(currentNode, nodeInfo)
            this.$refs.modelTree.append(nodeInfo, this.currentNodeData)
            this.$refs.modelTree.setChecked(nodeInfo, true)
          } else {
            // 编辑
            this.currentTreeNode.data.name = this.modifyForm.name
            currentNode = this.currentNodeData.node
            await this.player.Native.Node.setProperty(currentNode, { name: this.modifyForm.name })
          }
          this.modifyDialogClose()
        }
      })
    },
    // 关闭编辑框
    modifyDialogClose() {
      this.modifyForm = this.$options.data().modifyForm
      this.$refs.modifyForm.resetFields()
      this.modifyVisible = false
      this.isCreate = false
    },
    // 新增子节点
    createNode() {
      if (!this.currentNodeData.node) {
        this.$message.warning('请选择一个模型节点')
        return
      }
      if (
        !this.currentNodeData.code ||
        !isJSONObj(this.currentNodeData.code) ||
        (isJSONObj(this.currentNodeData.code) &&
          EnumObjectTypes.includes(JSON.parse(this.currentNodeData.code).type))
      ) {
        this.$message.warning('该节点不允许编辑')
        return
      }
      this.isCreate = true
      this.modifyVisible = true
    },
    // 删除节点
    async deleteNode() {
      if (!this.currentNodeData.node) {
        this.$message.warning('请选择一个模型节点')
        return
      }
      if (!isJSONObj(this.currentNodeData.code)) {
        this.$message.warning('该节点不允许删除')
        return
      }
      const codeInfo = JSON.parse(this.currentNodeData.code)
      if (codeInfo.type === 'Root' || codeInfo.type === 'engineering') {
        this.$message.warning('该节点无法删除')
        return
      }
      this.$confirm('是否删除该模型节点？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        lockScroll: false,
        type: 'warning',
      })
        .then(async () => {
          this.$refs.modelTree.remove(this.currentTreeNode)
          await this.player.Native.Node.destroy(this.currentNodeData.node)
          this.currentTreeNode = {}
          this.$emit('componentEmit', 'currentNodeData', {})
          this.$emit('componentEmit', 'deleteNode', this.currentNodeData.node)
        })
        .catch(() => {})
    },
    // 修改节点名称
    async editNodeName() {
      if (!this.currentNodeData.node) {
        this.$message.warning('请选择一个模型节点')
        return
      }
      if (
        !this.currentNodeData.code ||
        !isJSONObj(this.currentNodeData.code) ||
        (isJSONObj(this.currentNodeData.code) &&
          EnumObjectTypes.includes(JSON.parse(this.currentNodeData.code).type))
      ) {
        this.$message.warning('该节点不允许编辑')
        return
      }
      this.modifyVisible = true
      this.modifyForm.name = this.currentNodeData.name
    },
    // 右键点击弹出框
    showMenus(e, node, data) {
      if (!data.code || !isJSONObj(data.code)) {
        return
      }
      this.ableDelete =
        node.level > 1 && data.code && isJSONObj(data.code) && JSON.parse(data.code).type
      this.ableCreate =
        isJSONObj(data.code) && !EnumObjectTypes.includes(JSON.parse(data.code).type)
      this.ableEdit = isJSONObj(data.code) && !EnumObjectTypes.includes(JSON.parse(data.code).type)
      this.positon.X = e.clientX
      this.positon.Y = e.clientY
      this.menuVisible = true
      this.currentTreeNode = node
      this.$refs.modelTree.setCurrentKey(node, true)
      this.$emit('componentEmit', 'currentNodeData', data)
    },
    // 关闭弹窗
    closeComponent() {
      this.$confirm('是否保存模型节点信息？', '提示', {
        confirmButtonText: '保存',
        cancelButtonText: '取消',
        lockScroll: false,
        type: 'warning',
      })
        .then(async () => {
          this.saveEngineerData()
          this.$emit('closeComponent', 'ModelTree')
        })
        .catch(() => {
          this.$emit('closeComponent', 'ModelTree')
        })
    },
    // 模型树点击操作
    clickModelTree(data, node, doLocation) {
      if (data.isVirtual) {
        return
      }
      if (node && node.checked && doLocation) {
        this.multipleLocations(data)
        this.currentTreeNode = node
        this.$emit('componentEmit', 'currentNodeData', data)
      }
      this.$refs.modelTree.setCurrentKey(data.node)
    },
    async multipleLocations(data) {
      if (
        data.code &&
        isJSONObj(data.code) &&
        ['Root', 'userData'].includes(JSON.parse(data.code).type)
      ) return
      // 高亮选中的模型
      const selectNodes = await this.player.Native.Node.getSeletedNodes()
      await this.player.Native.Node.unSelectNodes(selectNodes)
      this.player.Native.Node.selectNodes([data.node])
      this.player.Native.Camera.moveToNode(data.node, 2, 5)
    },
    // 查看当前节点是否没有在影藏队列
    isNoFindModelHides(nodeObj) {
      return (
        _.indexOf(
          _.map(this.modelTreeProp.modelHideList, (res1) => {
            return res1.item
          }),
          nodeObj.data.item
        ) === -1
      )
    },
    checkModelTree(data, checkeds) {
      // 节点选中状态发生变化
      const isChecked = _.includes(checkeds.checkedKeys, data.node)
      if (data.isVirtual) {
        this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
        return
      }
      setModelVisible(
        this.player,
        'checkModelTree',
        isChecked,
        [data.node],
        this.modelTreeProp,
        checkeds
      )
    },
    // 模型树懒加载
    async loadNode(node, resolve) {
      let tempFilterKeys = _.filter(this.modelTreeProp.treeData, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      if (node.level === 0) {
        this.modelTreeProp.defaultCheckedKey = _.map(tempFilterKeys, (val) => {
          return val.node
        })
        return resolve(this.modelTreeProp.treeData)
      }
      let res = []
      if (node.data.isVirtual) {
        res = node.data.childs
      } else {
        const result = await this.player.Native.Node.getProperty(node.data.node, ['children'])
        res = result?.children || []
      }
      const step = 200
      if (res.length > step) {
        const shardingRes = []
        for (let i = 0; i < _.ceil(res.length / step); i += 1) {
          shardingRes.push({
            name: `${i * step + 1}~${(i + 1) * step}`,
            checked: true,
            code: `${node.data.code}${i}`,
            node: `${node.data.node}${i}`,
            parentNode: node.data.node,
            visible: true,
            childs: res.slice(i * step, (i + 1) * step),
            isVirtual: true,
          })
        }
        res = shardingRes
      }
      const filterRes = _.filter(res, (el) => {
        return el?.name
      })
      // 控制模型树的选中按钮
      tempFilterKeys = _.filter(filterRes, (el) => {
        return this.modelTreeProp.filterItem.indexOf(el.node) === -1
      })
      const tempCheckedKey = _.map(tempFilterKeys, (val) => {
        return val.node
      })
      // 过滤勾选状态为选中的子集
      const checkedKeys = _.map(
        _.filter(filterRes, (res4) => {
          return res4.name
        }),
        (res5) => {
          return res5.node
        }
      )
      // 查看当前节点是否没有在隐藏队列
      // 保存this指向
      const _this = this
      const isNoFindModelHides = (nodeObj) => {
        return (
          _.indexOf(
            _.map(_this.modelTreeProp.modelHideList, (res1) => {
              return res1.node
            }),
            nodeObj.data.node
          ) === -1
        )
      }
      if (isNoFindModelHides(node)) {
        // 没有在隐藏队列中
        let node1 = node
        while (node1.level !== 0) {
          // 向上查找没有在隐藏队列的父辈节点
          if (isNoFindModelHides(node1)) {
            node1 = node1.parent
          } else {
            // 父级在隐藏队列就结束向上查找
            break
          }
        }
        if (node1.level === 0) {
          // 如果查找到跟节点都没有在隐藏队列中，那么就代表全是勾选状态，不存在半选
          this.modelTreeProp.defaultCheckedKey = [
            ...this.modelTreeProp.defaultCheckedKey,
            ...tempCheckedKey,
          ]
        } else if (_.some(filterRes, { checked: false })) {
          // 中间父级可能是半选或者空白
          // 通过父获取子集的状态,如果子集中有一个为false，那么就把父级从默认选中框中去除掉，然后在设置子集节点状态
          this.modelTreeProp.defaultCheckedKey = [
            ..._.filter(this.modelTreeProp.defaultCheckedKey, (val) => {
              return val !== node.data.node
            }),
            ...checkedKeys,
          ]
        }
      } else {
        // 在隐藏队列表
        this.modelTreeProp.defaultCheckedKey = [
          ...this.modelTreeProp.defaultCheckedKey,
          ...checkedKeys,
        ]
      }
      resolve(filterRes)
      _.forEach(filterRes, (el) => {
        if (this.currentNodeData.node) {
          if (el.node === this.currentNodeData.node) {
            setTimeout(() => {
              this.locationNode(this.currentNodeData.node)
            }, 1000)
          }
        }
      })
      if (this.modelTreeProp.defaultCheckedKey) {
        // this.treeShow = false
        // this.treeShow = true
        this.$nextTick(() => {
          if (this.$refs.modelTree) {
            this.$refs.modelTree.setCheckedKeys(this.modelTreeProp.defaultCheckedKey)
          }
        })
      }
    },
    // 定位树节点
    locationNode(id) {
      this.$nextTick(() => {
        this.$refs.modelTree.setCurrentKey(id)

        setTimeout(async () => {
          const node = document.getElementById('modelTree')
          const waitForCurrentNode = (interval = 100) => {
            return new Promise((resolve, reject) => {
              let attempts = 0
              const maxAttempts = 50 // 最多尝试50次，防止无限循环
              const checkNode = () => {
                const currentNode = document.getElementsByClassName('is-current')[0]
                if (currentNode) {
                  resolve(currentNode)
                } else if (attempts < maxAttempts) {
                  attempts += 1
                  setTimeout(checkNode, interval)
                } else {
                  reject(new Error('未能在规定时间内找到 is-current 元素'))
                }
              }

              checkNode()
            })
          }
          const currentNode = await waitForCurrentNode()
          currentNode?.offsetTop &&
            node.scrollTo({
              top: currentNode.offsetTop,
            })
        }, 50)
      })
    },
    // 允许拖拽
    allowDrag(node) {
      return (
        node.data.code && isJSONObj(node.data.code) && JSON.parse(node.data.code).type !== 'Root'
      )
    },
    allowDrop(dragNode, dropNode) {
      return (
        dropNode.data.code &&
        isJSONObj(dropNode.data.code) &&
        !EnumObjectTypes.includes(JSON.parse(dropNode.data.code).type)
      )
    },
    // 拖拽结束
    async handleNodeDrop(beforeNode, afterNode) {
      this.player.Native.Node.setProperty(beforeNode.data.node, { parent: afterNode.data.node })
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/style/index';

.model-edit {
  background-color: rgba(0, 18, 55, 0.3) !important;
  border: none !important;
}

.menu-card {
  background-color: rgba(24, 41, 72, 0.8);

  .menu-item:hover {
    background-color: rgba(0, 116, 201, 0.4);
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: #fff !important;
}

::v-deep .el-card {
  &__body {
    padding: 0 !important;
    height: calc(100% - 30px);
    background-color: rgba(24, 41, 72, 0.5) !important;
    border-radius: 2px;
  }
}

::v-deep .el-loading-mask {
  background-color: rgba(24, 41, 72, 0.8) !important;
}

::v-deep .el-tree {
  height: 100% !important;
}

::v-deep .el-card .el-card__header {
  background: transparent !important;
}

::v-deep .el-button.el-tooltip {
  padding: 0 !important;
  width: 25px !important;
  height: 25px !important;
  line-height: 1 !important;
}

::v-deep .el-input-group__append {
  padding: 0;

  .el-button {
    margin: 0 !important;
    color: #fff !important;
    background-color: #46a6ff !important;
    border-color: #46a6ff !important;

    .iconfont {
      font-size: 14px !important;
    }
  }

  .el-button:nth-child(2) {
    margin-left: 1px !important;
  }
}

#rotateImg {
  transform: rotateX(180deg);
}
</style>
